import React from 'react'
import c from 'classnames'
import { connect } from 'react-redux'
import isEmpty from 'lodash/isEmpty'

import Button from 'discada/dist/Button'

import { VehicleChip } from './VehicleChip'
import FlipChip from './FlipChip'

import { getEntity } from 'selectors/entitySelectors'

import './InventoryChip.scss'
import './DealChip.scss'

export function DealChip(props) {
  return (
    <FlipChip
      className={c('deal-chip', 'vehicle-chip', props.className)}
      front={({ flip, side }) => (
        <VehicleChip {...props} hasFlip flip={flip} side={side}>
          <div className="deal-inner">
            <div className="chip-column persons">
              <span>Casandra Nguyen</span>
              <small>w/ Alex Snyder</small>
            </div>
            <div className="chip-column activity">
              <div className="interaction-icons">
                <i className="fas fa-arrow-left direction-icon  received" />
                <i className="fas interaction-icon fa-comment-alt" />
                <br />
                <div className="interaction-description">3 hrs ago</div>
              </div>
            </div>
          </div>
        </VehicleChip>
      )}
      back={({ flip, side }) => (
        <VehicleChip {...props} hasFlip flip={flip} side={side}>
          <div className="deal-actions">
            <div className="actions-1">
              <Button icon="certificate">Start Quote</Button>
            </div>
            <div className="actions-2">
              <Button icon="comment-alt">Contact</Button>
            </div>
            <div className="actions-3">
              <Button icon="check">Something</Button>
            </div>
            <div className="actions-4">
              <Button icon="certificate">Start Quote</Button>
            </div>
          </div>
        </VehicleChip>
      )}
    />
  )
}

function mapStateToProps(state, op) {
  let vehicle = getEntity(state, op.id)

  return {
    ...op,
    vehicle,
    isLoading: isEmpty(vehicle),
  }
}

export default connect(mapStateToProps)(DealChip)
